import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './Contact.css';


const redIcon = new L.Icon({
  iconUrl: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
  iconSize: [36, 36],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const blackIcon = new L.Icon({
  iconUrl: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const Contacts = () => {
  const [name, setName] = useState('');
  const [lastname, setLastname] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [comments, setComments] = useState('');
  const [address, setAddress] = useState('');
  const [isAgreed, setIsAgreed] = useState(false); // State to track checkbox

  const locations = [
    { name: 'Head Office', position: [11.1085, 77.3411], address: '#37A Ramnagar 1st St, Tirupur, India 641602', isHeadOffice: true },
    { name: 'Chennai', position: [13.0827, 80.2707], address: '#9/2, Vivekananda St, Arumbakkam, Chennai 600106', isHeadOffice: false },
    { name: 'Bengaluru', position: [12.9716, 77.5946], address: '#4, 21st, Narayana Nagar, Konanakunte, Bengaluru 560062', isHeadOffice: false },
    { name: 'Coimbatore', position: [11.0168, 76.9558], address: '#1, 1st Fl, RG Pudur Pirivu, Coimbatore 641062', isHeadOffice: false },
    { name: 'Hyderabad', position: [17.4949, 78.3995], address: '2-22-85/B, Allwyn colony rd, Vivekananda Nagar, Kukatpally, Hyderabad, Telangana 500072', isHeadOffice: false }
  ];


  const handleSubmit = (e) => {
    e.preventDefault();
    if (isAgreed) {
    } else {
      alert("Please agree to the Privacy Policy before submitting.");
    }
  };
  

  return (
    <>
      <div className="header-title">
        <h1>Contact Us</h1>
      </div>

      {/* Map View */}
      <div className="map-container">
        <MapContainer center={[11.1085, 77.3411]} zoom={5} scrollWheelZoom={false} style={{ height: '500px', width: '100%' }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          {locations.map((location, index) => (
  <Marker
    key={index}
    position={location.position}
    icon={location.isHeadOffice ? redIcon : blackIcon}
    eventHandlers={{
      mouseover: (event) => {
        const marker = event.target;
        marker.openPopup(); 
      },
      mouseout: (event) => {
        const marker = event.target;
        marker.closePopup(); 
      },
      click: () => {
        const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${location.position[0]},${location.position[1]}`;
        window.open(googleMapsUrl, '_blank');
      },
    }}
  >
    <Popup>
      <strong>{location.name}</strong>
      <br />
      {location.address}
      <br />
      <button
        onClick={() => {
          const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${location.position[0]},${location.position[1]}`;
          window.open(googleMapsUrl, '_blank');
        }}
        style={{
          background: 'none',
          border: 'none',
          color: 'blue',
          textDecoration: 'underline',
          cursor: 'pointer',
          padding: 0,
        }}
      >
        {/* Get Directions */}
      </button>
    </Popup>
  </Marker>
))}

        </MapContainer>
      </div>

      <div className="contact-container">
        <div className="contact-details">
          <div className="contact-box">
            <div className="icon-container">
              <i className="fas fa-phone-alt animated-icon"></i>
            </div>
            <h2>Phone Numbers</h2>
            <p>South India: +91 9843384444</p>
            <p>North India: +91 9445105983</p>
          </div>
          <div className="contact-box">
            <div className="icon-container">
              <i className="fas fa-envelope animated-icon"></i>
            </div>
            <h2>Email</h2>
            <p>info@groupsui.in</p>
          </div>
        </div>

        <div className="contact-form-container">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <input 
                  type="text" 
                  id="name" 
                  value={name} 
                  onChange={(e) => setName(e.target.value)} 
                  placeholder="First Name" 
                  required 
                />
              </div>
              <div className="form-group">
                <input 
                  type="tel" 
                  id="lastname" 
                  value={lastname} 
                  onChange={(e) => setLastname(e.target.value)} 
                  placeholder="Last Name" 
                  required 
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <input 
                  type="text" 
                  id="Email Address" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  placeholder="Email Address" 
                  required 
                />
              </div>
              <div className="form-group">
                <input 
                  type="tel" 
                  id="phone" 
                  value={phone} 
                  onChange={(e) => setPhone(e.target.value)} 
                  placeholder="Phone Number" 
                  required 
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <input 
                  type="text" 
                  id="address" 
                  value={address} 
                  onChange={(e) => setAddress(e.target.value)} 
                  placeholder="Address" 
                  required 
                />
              </div>
            </div>
            <div className="form-group">
              <textarea 
                id="comments" 
                value={comments} 
                onChange={(e) => setComments(e.target.value)} 
                placeholder="Comments" 
                required
              ></textarea>
            </div>
            <div className="remember-me">
            <input
            type="checkbox"
            id="agree"
            checked={isAgreed}
            onChange={(e) => setIsAgreed(e.target.checked)}
          />
              <p>
                <span>By clicking “Submit" you confirm you intend to interact with and disclose personal information to SSKV Techbuilds and you have read and agree to our</span>
                <span className='privacy'> Privacy policy</span> .
              </p>
            </div>
            <div className="send">
    <button
        type="submit"
        className="submit-button"
        style={{ backgroundColor: '#EE741D', color: 'white' }}
    >
        Submit
    </button>
</div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Contacts;
